import { render, staticRenderFns } from "./DmsCabinetTree.vue?vue&type=template&id=1f050640"
import script from "./DmsCabinetTree.vue?vue&type=script&lang=js"
export * from "./DmsCabinetTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports